import Globals from '../Globals';

export default {
  ...Globals,

  primary: '#2d2d8f',
  primarySlightFade: '#5f5fd9',
  primaryFade: '#d0d0f0',
  primaryDarker: '#1b1b55',

  secondary: '#283270',
};
